/**
 * Tiny class-name joiner. Filters out falsy values and joins with spaces.
 * Avoids a `clsx` / `classnames` dep for this small surface.
 */
export function cn(
  ...args: Array<string | number | undefined | null | false | Record<string, boolean>>
): string {
  const out: string[] = [];
  for (const arg of args) {
    if (!arg) continue;
    if (typeof arg === 'string' || typeof arg === 'number') {
      out.push(String(arg));
    } else {
      for (const [key, on] of Object.entries(arg)) if (on) out.push(key);
    }
  }
  return out.join(' ');
}
